// Shared retry-on-409 logic for TIMESHEET_CONFLICT responses from the
// schedule API's destroy()/destroySeries()/adjustSeries() endpoints. A
// component mixing this in must render a
// <timesheet-conflict-modal ref="conflictModal" /> somewhere in its template.
export default {
  methods: {
    // requestFn(forceArgs) performs the request with forceArgs merged in
    // ({} on the first try, { force: true, confirmed } on a retry) and
    // either resolves normally or throws the axios error. Resolves to
    // requestFn's return value, or rejects with a `.timesheetConflictCancelled`
    // error if the user dismisses the conflict dialog instead of confirming.
    async withTimesheetConflictRetry(
      requestFn,
      confirmLabel = 'Delete anyway',
    ) {
      let forceArgs = {}
      // Bounded, not infinite — a conflict that keeps reappearing across
      // several confirmed retries (e.g. a worker actively logging hours
      // during the flow) should stop re-prompting and surface as a real
      // error instead of trapping the user in a loop.
      for (let attempt = 0; attempt < 5; attempt++) {
        try {
          return await requestFn(forceArgs)
        } catch (e) {
          const responseData = (e && e.response && e.response.data) || {}
          if (responseData.error_code !== 'TIMESHEET_CONFLICT') {
            throw e
          }
          const confirmed = await this.$refs.conflictModal.show(
            responseData.conflicts,
            confirmLabel,
          )
          if (!confirmed) {
            const cancelled = new Error(
              'Timesheet conflict — cancelled by user',
            )
            cancelled.timesheetConflictCancelled = true
            throw cancelled
          }
          forceArgs = { force: true, confirmed }
        }
      }
      throw new Error('Too many timesheet-conflict retries')
    },
  },
}
